import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaPlay, FaPause, FaRedo, FaArrowLeft, FaCog } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const PomodoroPage = () => {
    // Timer modes in minutes
    const [modes, setModes] = useState({
        work: 25,
        shortBreak: 5,
        longBreak: 15
    });

    const [mode, setMode] = useState('work'); // 'work', 'shortBreak', 'longBreak'
    const [timeLeft, setTimeLeft] = useState(modes.work * 60);
    const [isActive, setIsActive] = useState(false);
    const [showSettings, setShowSettings] = useState(false);

    // Using ref for interval to clear it properly
    const intervalRef = useRef(null);

    // Update timer when mode changes or Settings change
    useEffect(() => {
        setTimeLeft(modes[mode] * 60);
        setIsActive(false);
        if (intervalRef.current) clearInterval(intervalRef.current);
    }, [mode, modes]);

    // Timer logic
    useEffect(() => {
        if (isActive && timeLeft > 0) {
            intervalRef.current = setInterval(() => {
                setTimeLeft((prev) => prev - 1);
            }, 1000);
        } else if (timeLeft === 0) {
            // Timer finished
            setIsActive(false);
            if (intervalRef.current) clearInterval(intervalRef.current);
            // Play sound prompt here if needed
            alert("Süre doldu!");
        }

        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [isActive, timeLeft]);

    const toggleTimer = () => {
        setIsActive(!isActive);
    };

    const resetTimer = () => {
        setIsActive(false);
        setTimeLeft(modes[mode] * 60);
    };

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    const getProgress = () => {
        const totalSeconds = modes[mode] * 60;
        const progress = ((totalSeconds - timeLeft) / totalSeconds) * 100;
        return progress;
    };

    const handleSettingChange = (e, settingMode) => {
        const val = parseInt(e.target.value);
        if (!isNaN(val) && val > 0) {
            setModes(prev => ({ ...prev, [settingMode]: val }));
        }
    };

    return (
        <div className="pomodoro-page">
            <div className="container">
                <div className="pomodoro-nav">
                    <Link to="/" className="back-link">
                        <FaArrowLeft /> Ana Sayfaya Dön
                    </Link>
                </div>

                <motion.div
                    className="pomodoro-container"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <div className="pomodoro-header-row">
                        <h1 className="pomodoro-title">Online Pomodoro</h1>
                        <button className="settings-toggle" onClick={() => setShowSettings(!showSettings)}>
                            <FaCog />
                        </button>
                    </div>

                    {showSettings && (
                        <motion.div
                            className="pomodoro-settings"
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: 'auto', opacity: 1 }}
                        >
                            <label>
                                Çalışma (dk):
                                <input
                                    type="number"
                                    value={modes.work}
                                    onChange={(e) => handleSettingChange(e, 'work')}
                                    className="settings-input"
                                />
                            </label>
                            <label>
                                Kısa Mola (dk):
                                <input
                                    type="number"
                                    value={modes.shortBreak}
                                    onChange={(e) => handleSettingChange(e, 'shortBreak')}
                                    className="settings-input"
                                />
                            </label>
                            <label>
                                Uzun Mola (dk):
                                <input
                                    type="number"
                                    value={modes.longBreak}
                                    onChange={(e) => handleSettingChange(e, 'longBreak')}
                                    className="settings-input"
                                />
                            </label>
                        </motion.div>
                    )}

                    <div className="mode-selector">
                        <button
                            className={`mode-btn ${mode === 'work' ? 'active' : ''}`}
                            onClick={() => setMode('work')}
                        >
                            Çalışma
                        </button>
                        <button
                            className={`mode-btn ${mode === 'shortBreak' ? 'active' : ''}`}
                            onClick={() => setMode('shortBreak')}
                        >
                            Kısa Mola
                        </button>
                        <button
                            className={`mode-btn ${mode === 'longBreak' ? 'active' : ''}`}
                            onClick={() => setMode('longBreak')}
                        >
                            Uzun Mola
                        </button>
                    </div>

                    <div className="timer-display">
                        <div className="progress-ring" style={{ '--progress': `${getProgress()}%` }}>
                            <div className="timer-text">{formatTime(timeLeft)}</div>
                        </div>
                    </div>

                    <div className="timer-controls">
                        <button className="control-btn main-btn" onClick={toggleTimer}>
                            {isActive ? <FaPause /> : <FaPlay />}
                            {isActive ? 'Durdur' : 'Başlat'}
                        </button>
                        <button className="control-btn reset-btn" onClick={resetTimer}>
                            <FaRedo />
                        </button>
                    </div>
                </motion.div>
            </div>
            <Footer />
        </div>
    );
};

export default PomodoroPage;
